/** Русские строки интерфейса. Ключи типизированы: опечатка в t('...') — ошибка компиляции. */
export const ru = {
  app: {
    name: 'Numistic',
    tagline: 'Каталог монет и банкнот',
  },
  common: {
    retry: 'Повторить',
    save: 'Сохранить',
    cancel: 'Отмена',
    add: 'Добавить',
    remove: 'Удалить',
    edit: 'Изменить',
    yes: 'Да',
    no: 'Нет',
    notSet: '—',
    loading: 'Загрузка…',
    search: 'Поиск',
    close: 'Закрыть',
  },
  catalog: {
    title: 'Каталог',
    searchPlaceholder: 'Название, номер (KM# 123, Pick 45)…',
    allTypes: 'Все типы',
    sort: 'Сортировка',
    sorts: {
      relevance: 'По релевантности',
      title: 'По названию',
      year: 'По году',
      recent: 'Сначала новые',
    },
    viewGrid: 'Плитка',
    types: 'Типы',
    viewTable: 'Таблица',
    filters: 'Фильтры',
    mine: 'Только мои приватные',
    owned: {
      label: 'Моя коллекция',
      all: 'Все',
      yes: 'Есть у меня',
      no: 'Нет у меня',
    },
    ownedBadge: 'В коллекции',
    ownedBadgeCount: 'В коллекции · {{count}}',
    wantedBadge: 'В поиске',
    add: 'Добавить запись',
    more: 'Показать ещё',
    empty: 'Ничего не найдено.',
    noImage: 'Нет фото',
    visibility: 'Видимость',
    visibilities: { public: 'Всем', members: 'Только участникам', private: 'Только мне' },
    own: {
      have_one: 'У вас {{count}} экземпляр:',
      have_few: 'У вас {{count}} экземпляра:',
      have_many: 'У вас {{count}} экземпляров:',
      have_other: 'У вас {{count}} экземпляра:',
      none: 'В вашей коллекции этого нет.',
      specimen: 'экземпляр',
      add: 'В мою коллекцию',
      want: 'Ищу',
    },
    newTitle: 'Новая запись каталога',
    chooseType: 'Что добавляем?',
    create: 'Создать',
    edit: 'Изменить',
    delete: 'Удалить',
    deleteConfirm: 'Удалить запись из каталога?',
    back: 'К каталогу',
    tabs: { data: 'Данные', images: 'Изображения', variants: 'Разновидности' },
    variants: 'Разновидности',
    variantLabel: 'Название разновидности',
    variantAdd: 'Добавить разновидность',
    noVariants: 'Разновидностей нет.',
    conflict: 'Запись уже изменили в другом окне. Обновите страницу — ваши правки не сохранены.',
    autoTitle: 'Если оставить пустым, название соберётся по шаблону типа.',
    saved: 'Сохранено',
    images: {
      title: 'Фото',
      drop: 'Перетащите фото сюда или выберите файлы',
      choose: 'Выбрать файлы',
      uploading: 'Загрузка…',
      role: 'Роль',
      roles: { obverse: 'Аверс', reverse: 'Реверс', edge: 'Гурт', slab: 'Слаб', other: 'Другое' },
      rotateLeft: 'Повернуть влево',
      rotateRight: 'Повернуть вправо',
      crop: 'Кадрировать',
      cropHint: 'Выделите область мышью. Оригинал не меняется.',
      cropApply: 'Применить',
      cropReset: 'Сбросить кадр',
      moveUp: 'Выше',
      moveDown: 'Ниже',
      remove: 'Убрать фото',
      original: 'Оригинал',
      empty: 'Фотографий пока нет.',
      unsupported:
        'Формат не поддерживается (JPEG, PNG, WebP, AVIF, TIFF). HEIC с iPhone сохраните как JPEG.',
      tooLarge: 'Файл больше 25 МБ.',
    },
  },
  numista: {
    title: 'Импорт из Numista',
    open: 'Импорт из Numista',
    hint: 'Найдите монету или банкноту в каталоге Numista и перенесите её к себе вместе с номерами, выпусками и фото.',
    notConfigured: 'Импорт недоступен: на сервере не задан ключ Numista API.',
    searchPlaceholder: 'Название, страна, номер KM…',
    search: 'Найти',
    found: 'Найдено: {{count}}',
    nothing: 'Ничего не найдено.',
    prev: '← Назад',
    next: 'Далее →',
    inCatalog: 'в каталоге',
    inMine: 'в моих записях',
    preview: 'Предпросмотр',
    type: 'Тип объекта',
    issuer: 'Эмитент',
    issuerHint: 'Эмитент Numista «{{name}}» не найден в справочнике — выберите вручную.',
    unmatched: 'Не сопоставлено (не будет перенесено)',
    willCreate: 'Будет добавлено в справочники при импорте (название — как в Numista)',
    variants: 'Выпуски → разновидности',
    images: 'Фото',
    importCatalog: 'Импортировать в общий каталог',
    updateCatalog: 'Обновить запись в каталоге',
    importPrivate: 'Импортировать в мои записи',
    updatePrivate: 'Обновить мою запись',
    catalogNote: 'Запись в общем каталоге будет видна только вошедшим пользователям.',
    openExisting: 'Открыть',
    done: 'Импортировано',
    doneWithSpecimen: 'Импортировано и добавлено в коллекцию',
    issuerRequired: 'Эмитент Numista не найден в справочнике — выберите его выше и повторите.',
    bulk: {
      title: 'Импорт выбранного',
      pick: 'Выбрать для импорта: {{title}}',
      selected: 'Выбрано: {{count}}',
      clear: 'Снять выбор',
      target: 'Куда импортировать',
      addToCollection: 'Сразу добавить в мою коллекцию',
      collection: 'Коллекция',
      inbox: 'Входящие',
      quotaHint: 'До {{requests}} запросов Numista (уже открытые — из кэша).',
      quotaLeft: 'Осталось в этом месяце: {{left}}.',
      runCatalog: 'Импортировать в каталог ({{count}})',
      runPrivate: 'Импортировать в мои записи ({{count}})',
      running: 'Импорт…',
      openItem: 'Запись',
      openSpecimen: 'Экземпляр',
      issuerSkipped: 'Пропущено: эмитент не найден в справочнике.',
      pickIssuer: 'Выбрать эмитента',
      hideReport: 'Скрыть отчёт',
    },
    quota: 'Numista: {{used}} из {{quota}} запросов, {{month}}',
    startHint:
      'Введите название или откройте «Фильтры» (страна, каталог и номер, годы) и нажмите «Найти». Поиск тратит квоту Numista.',
    pickHint: 'Выберите тип слева — здесь появится предпросмотр полей, фото и выпусков.',
    page: '{{page}} из {{pages}}',
    openOnNumista: 'открыть на Numista',
    filters: {
      toggle: 'Фильтры',
      category: 'Категория',
      any: 'Любая',
      categories: { coin: 'Монеты', banknote: 'Банкноты', exonumia: 'Экзонумия (жетоны, медали…)' },
      issuer: 'Эмитент (страна)',
      catalogue: 'Каталог и номер',
      number: 'Номер',
      order: 'Сортировка',
      orderAuto: 'Авто',
      orders: {
        relevance: 'По совпадению',
        value: 'По номиналу',
        date: 'По дате выпуска',
        reference: 'По номеру каталога',
      },
      date: 'Годы выпуска',
      year: 'Год на предмете',
      yearHint: 'Как написан на предмете, в том числе по другому календарю',
      yearPlaceholder: '1917 или 1800-1850',
      size: 'Размер, мм',
      weight: 'Вес, г',
      from: 'от',
      to: 'до',
      apply: 'Найти с фильтрами',
      reset: 'Сбросить',
      hint: 'Numista ищет по тексту, эмитенту, каталогу или годам — хотя бы одно из них нужно.',
    },
    watermark: 'Водяной знак',
    loadingPreview: 'Загружаю данные Numista и перевожу описания…',
    quotaTitle: 'Numista API',
  },
  settings: {
    title: 'Настройки',
    tabs: {
      profile: 'Профиль',
      collections: 'Коллекции',
      locations: 'Места хранения',
      tags: 'Теги и подборки',
      counterparties: 'Продавцы и площадки',
      devices: 'Устройства',
      data: 'Импорт и экспорт',
    },
  },
  tree: {
    dragHint: 'Перетащите узел на другой, чтобы вложить, или выберите его и измените родителя.',
    ownCount: 'Экземпляров непосредственно здесь: {{count}}',
    name: 'Название',
    parent: 'Внутри',
    description: 'Описание',
    newChild: 'Вложенный узел — название',
    kinds: { album: 'Альбом', sheet: 'Лист', cell: 'Ячейка', box: 'Коробка', other: 'Другое' },
    collections: {
      title: 'Коллекции',
      root: 'Верхний уровень',
      empty: 'Коллекций пока нет.',
      newRoot: 'Новая коллекция',
      pick: 'Выберите коллекцию в списке — здесь можно переименовать её, перенести, описать, поделиться ссылкой или удалить.',
      deleteConfirm:
        'Удалить коллекцию «{{name}}»? Вложенные коллекции и экземпляры перейдут к родителю (или во «Входящие»).',
      open: 'Открыть экземпляры',
    },
    locations: {
      title: 'Места хранения',
      root: 'Верхний уровень',
      empty: 'Мест хранения пока нет — добавьте альбом, коробку или шкаф.',
      newRoot: 'Новое место',
      pick: 'Выберите место в списке — здесь можно переименовать его, изменить вид, перенести или удалить, а ниже видно, что в нём лежит.',
      deleteConfirm:
        'Удалить место хранения «{{name}}»? Вложенные места и экземпляры перейдут к родителю.',
    },
  },
  tags: {
    title: 'Теги',
    hint: 'Теги — свободные метки экземпляров («редкость», «на обмен»). Назначаются в карточке экземпляра и в массовой правке.',
    empty: 'Тегов пока нет.',
    new: 'Новый тег',
    rename: 'Название тега «{{name}}»',
    color: 'Цвет',
    specimens: 'Экземпляров: {{count}}',
    deleteConfirm: 'Удалить тег «{{name}}»? Он снимется с экземпляров ({{count}}).',
  },
  counterparties: {
    title: 'Продавцы и площадки',
    hint: 'Магазины, аукционы, дилеры и люди, с кем вы покупали, продавали и менялись. Справочник пополняется сам из поля «Где / у кого»; здесь можно задать вид, сайт и заметку.',
    empty: 'Пока пусто — укажите «Где / у кого» при покупке, и продавец появится здесь.',
    new: 'Новый продавец или площадка',
    placeholder: 'Магазин, аукцион, человек…',
    willAdd: 'Новое название — добавится в справочник продавцов',
    name: 'Название',
    renameHint: 'Переименование обновит подпись и в уже записанных сделках',
    kind: 'Вид',
    url: 'Сайт',
    note: 'Заметка',
    site: 'сайт',
    deals: 'Сделок: {{count}}',
    spent: 'потрачено',
    earned: 'выручено',
    last: 'последняя',
    deleteConfirm:
      'Удалить «{{name}}» из справочника? Записанные сделки останутся с этой подписью.',
  },
  views: {
    title: 'Подборки',
    hint: 'Сохранённые фильтры коллекции. Создаются на странице коллекций кнопкой «Сохранить как умную коллекцию».',
    empty: 'Сохранённых подборок нет.',
    conditions: 'Условий: {{count}}',
    deleteConfirm: 'Удалить подборку «{{name}}»? Экземпляры не удаляются.',
  },
  lightbox: {
    open: 'Открыть фото: {{name}}',
    zoomHint: 'Нажмите, чтобы увеличить',
    zoomIn: 'Приблизить',
    zoomOut: 'Отдалить',
    reset: 'Исходный масштаб',
    original: 'Оригинал',
    close: 'Закрыть',
    prev: 'Предыдущее фото',
    next: 'Следующее фото',
    hint: 'Колесо или щипок — масштаб, перетаскивание — сдвиг, двойной клик — приблизить, ← → — листать, Esc — закрыть',
  },
  translation: {
    language: 'Язык текстов',
    russian: 'Русский',
    original: 'Оригинал',
    importRu:
      'Будет импортировано на русском; оригинал сохранится — его можно посмотреть в записи.',
    importOriginal: 'Будет импортировано без перевода — как в Numista.',
    translatedNote: 'Тексты переведены с Numista автоматически.',
    partial:
      'Часть текстов перевести не удалось (сервис перевода недоступен или дневной лимит исчерпан) — они останутся на языке Numista.',
  },
  collections: {
    title: 'Мои коллекции',
    all: 'Все экземпляры',
    newRoot: 'Новая коллекция',
    newChild: 'Вложенная',
    rename: 'Переименовать',
    delete: 'Удалить',
    deleteConfirm: 'Удалить коллекцию? Экземпляры и вложенные коллекции перейдут к родителю.',
    deleteLocationConfirm:
      'Удалить место хранения «{{name}}»? Вложенные места и экземпляры перейдут к родителю.',
    locationKind: 'Вид места',
    namePrompt: 'Название коллекции',
    inbox: 'Входящие',
    includeChildren: 'Включая вложенные',
    countTitle: 'Здесь: {{own}}, всего с вложенными: {{total}}',
    moveHere: 'Переместить сюда',
    moveToRoot: 'В корень',
    dragHint: 'Перетащите коллекцию на другую, чтобы вложить её.',
    manage: 'Управлять коллекциями',
    cycle: 'Нельзя вложить коллекцию в саму себя или в её потомка.',
    addSpecimen: 'Добавить экземпляр',
    selected: 'Выбрано: {{count}}',
    bulkMove: 'Перенести в…',
    bulkStatus: 'Сменить статус…',
    saveView: 'Сохранить как умную коллекцию',
    saveViewPrompt: 'Название умной коллекции',
    views: 'Умные коллекции',
    wanted: 'В поиске',
    forSale: 'На продаже',
    empty: 'Экземпляров нет.',
  },
  specimen: {
    overridesOff:
      'Ниже — поля этого экземпляра. Данные каталога (название, страна, годы…) наследуются; переопределите их, если ваш экземпляр отличается.',
    overridesOn: 'Пустое поле каталога — значит, как в каталоге (значение подписано под полем).',
    catalogPhotosHint:
      'Своих фото у экземпляра пока нет — на карточке показываются фото из записи каталога. Загрузите свои или возьмите фото каталога как основу.',
    copyCatalogPhotos: 'Взять фото из каталога',
    copyCatalogHint: 'Копии можно поворачивать, кадрировать и удалять — каталог не меняется.',
    summary: {
      bought: 'Покупка',
      value: 'Текущая оценка',
      where: 'Где лежит',
      none: 'Не указано',
      nowhere: 'Место не указано',
    },
    deleteConfirm: 'Удалить экземпляр вместе с его историей, оценками и заметками?',
    newTitle: 'Новый экземпляр',
    pickCatalog: 'Шаг 1. Запись каталога',
    pickCatalogHint:
      'Найдите монету или банкноту в каталоге. Если её нет — создайте приватную запись.',
    createPrivate: 'Нет в каталоге — создать запись',
    findInNumista: 'Найти в Numista',
    change: 'Выбрать другую',
    details: 'Шаг 2. Экземпляр',
    acquisition: 'Покупка',
    acquisitionHint: 'Необязательно. Сохранится в журнале событий.',
    showOverrides: 'Переопределить поля каталога',
    hideOverrides: 'Скрыть поля каталога',
    create: 'Добавить в коллекцию',
    fromCatalog: 'Запись каталога',
    own: 'свой',
    events: 'Журнал',
    eventAdd: 'Добавить событие',
    eventKinds: {
      acquired: 'Покупка',
      listed: 'Выставлен на продажу',
      unlisted: 'Снят с продажи',
      sold: 'Продажа',
      exchanged: 'Обмен',
      graded: 'Слабирование',
      status_changed: 'Смена статуса',
      custom: 'Другое',
    },
    date: 'Дата',
    amount: 'Сумма',
    currency: 'Валюта',
    fees: 'Комиссия / доставка',
    counterparty: 'Где / у кого (кому)',
    source: 'Источник',
    lot: 'Номер лота',
    place: 'Место',
    note: 'Комментарий',
    notes: 'Заметки',
    noteAdd: 'Добавить заметку',
    notePlaceholder: 'Состояние, история, наблюдения…',
    noNotes: 'Заметок пока нет.',
    noEvents: 'Событий нет.',
    duplicate: 'Дублировать',
    tags: 'Теги',
    newTag: 'Новый тег',
    photos: 'Фото экземпляра',
    catalogPhotos: 'Фото из каталога',
    location: 'Где лежит',
  },
  stats: {
    title: 'Моя коллекция',
    byType: 'По типам',
    total: 'Всего экземпляров: {{count}}',
    pageTitle: 'Статистика',
    open: 'Статистика',
    spent: 'Потрачено',
    specimensOwned: 'Экземпляров в наличии',
    spentHint: 'Покупки с комиссиями, включая проданное',
    value: 'Текущая стоимость',
    valueHint: 'Последние оценки экземпляров в наличии: {{valued}} из {{owned}}',
    profit: 'Прибыль от продаж',
    profitHint: 'Выручка {{revenue}} − себестоимость {{cost}}',
    specimens: 'Экземпляров в выборке: {{count}}',
    unconverted:
      'Сумм без курса валюты: {{count}} — они не вошли в итоги. Курсы догружаются автоматически.',
    baseCurrency: 'Все суммы — в {{currency}} по курсу на дату покупки, продажи или оценки.',
    changeCurrency: 'Сменить валюту',
    groups: {
      issuer: 'Страны',
      type: 'Типы',
      year: 'Десятилетия',
      collection: 'Коллекции',
      status: 'Статусы',
      counterparty: 'Продавцы',
    },
    columns: { label: 'Группа', count: 'Шт.', spent: 'Потрачено', value: 'Стоимость' },
    empty: 'Нет данных.',
  },
  share: {
    open: 'Поделиться',
    title: 'Ссылки на «{{name}}»',
    hint: 'Просмотр без входа: без цен, покупок, оценок, заметок и места хранения.',
    includeChildren: 'Включая вложенные коллекции',
    expires: 'Действует до (необязательно)',
    create: 'Создать ссылку',
    created: 'Ссылка создана. Скопируйте её сейчас — позже показать её снова нельзя.',
    link: 'Ссылка',
    copy: 'Копировать',
    copied: 'Скопировано',
    existing: 'Выданные ссылки',
    createdAt: 'Создана {{date}}',
    withChildren: 'с вложенными',
    rootOnly: 'только эта коллекция',
    until: 'до {{date}}',
    revoked: 'отозвана',
    expired: 'истекла',
    revoke: 'Отозвать',
    unavailable: 'Ссылка недействительна: её отозвали или срок действия истёк.',
    ownerLine: 'Коллекция пользователя {{name}}',
    all: 'Все экземпляры',
    back: 'К коллекции',
  },
  io: {
    title: 'Импорт и экспорт',
    exportTitle: 'Выгрузка',
    exportHint:
      'JSON — полная копия (коллекции, места, теги, экземпляры с историей и заметками; без фото). CSV — таблица для Excel.',
    exportJson: 'Скачать JSON',
    exportCsv: 'Скачать CSV',
    exportView: 'Экспорт CSV',
    importTitle: 'Загрузка',
    importHint:
      'JSON-выгрузка Numistic или CSV-таблица. Сначала проверка — данные не меняются, затем импорт.',
    chooseFile: 'Выбрать файл…',
    mappingHint: 'Строк: {{rows}}. Сопоставьте колонки с полями — лишние можно пропустить.',
    column: 'Колонка',
    sample: 'Пример',
    target: 'Поле',
    targetFor: 'Поле для колонки «{{column}}»',
    skip: '— не импортировать —',
    check: 'Проверить',
    import: 'Импортировать',
    dryRunResult: 'Проверка: будет импортировано {{imported}} из {{rows}}.',
    doneResult: 'Готово: импортировано {{imported}} из {{rows}}.',
    created:
      'Коллекций: {{collections}}, мест: {{locations}}, тегов: {{tags}}, записей каталога: {{items}}, событий: {{events}}, оценок: {{valuations}}, заметок: {{notes}}.',
    skipped: 'Пропущено строк: {{count}}.',
    issues: 'Замечания',
    row: 'Строка {{row}}',
  },
  valuations: {
    title: 'Оценки',
    add: 'Добавить оценку',
    date: 'Дата оценки',
    amount: 'Стоимость',
    source: 'Источник',
    sourcePlaceholder: 'Каталог, аукцион, дилер…',
    empty: 'Оценок пока нет.',
    noRate: 'курс ещё не загружен',
    chart: 'График оценок',
  },
  profile: {
    title: 'Профиль',
    name: 'Имя',
    email: 'Email',
    baseCurrency: 'Базовая валюта',
    baseCurrencyHint:
      'В ней считаются итоги и статистика. После смены суммы пересчитываются по курсам на даты событий.',
    saved: 'Сохранено.',
  },
  sections: {
    main: 'Основное',
    physical: 'Физические характеристики',
    design: 'Оформление',
    paper: 'Бумага и печать',
    specimen: 'Экземпляр',
    notes: 'Описание и заметки',
  },
  meta: {
    required: 'обязательное',
    inherited: 'Из каталога: {{value}}',
    yearFrom: 'с',
    yearTo: 'по',
    partialDateHint: 'ГГГГ, ГГГГ-ММ или ГГГГ-ММ-ДД',
    amount: 'Сумма',
    currency: 'Валюта',
    scale: 'Шкала',
    grade: 'Значение',
    system: 'Каталог',
    number: 'Номер',
    addItem: 'Добавить',
    refUnavailable: 'Появится на следующих этапах',
    choose: 'Выберите…',
    noData: 'Нет данных',
  },
  filter: {
    title: 'Фильтры',
    add: 'Добавить условие',
    field: 'Поле',
    operator: 'Условие',
    value: 'Значение',
    clear: 'Сбросить',
    empty: 'Условий нет — показано всё.',
    ops: {
      eq: 'равно',
      neq: 'не равно',
      in: 'одно из',
      contains: 'содержит',
      gte: 'не меньше',
      lte: 'не больше',
      between: 'в диапазоне',
      is_set: 'заполнено',
      is_not_set: 'не заполнено',
    },
  },
  nav: {
    catalog: 'Каталог',
    collections: 'Коллекции',
    admin: 'Администрирование',
    devices: 'Устройства',
    tags: 'Теги',
    locations: 'Места хранения',
    stats: 'Статистика',
    profile: 'Профиль',
    menu: 'Меню',
    closeMenu: 'Закрыть меню',
    signIn: 'Войти',
    signOut: 'Выйти',
  },
  status: {
    ok: 'Сервер работает',
    degraded: 'Сервер работает с ограничениями',
    fail: 'Сервер недоступен',
    loading: 'Проверка сервера…',
    unreachable: 'Нет связи с сервером',
  },
  home: {
    title: 'Каталог монет и банкнот',
    guest: 'Войдите, чтобы вести свои коллекции. Регистрация — по приглашению.',
    welcome: 'Здравствуйте, {{name}}!',
    lead: 'Каталог монет, банкнот, жетонов и медалей и учёт личной коллекции: покупки, оценки, фото, статистика.',
    openCatalog: 'Открыть каталог',
    recentCatalog: 'Новое в каталоге',
    recentSpecimens: 'Недавно добавленные',
    allSpecimens: 'Все экземпляры →',
    findInCatalog: 'Найти в каталоге',
    steps: {
      title: 'С чего начать',
      collections: 'Создайте коллекции',
      collectionsText:
        'Например, «Монеты → СССР» — вложенность любая, порядок меняется перетаскиванием.',
      add: 'Добавьте экземпляр',
      addText: 'Найдите монету в каталоге, укажите грейд, покупку и фото.',
      numista: 'Нет в каталоге?',
      numistaText: 'Импортируйте запись из Numista или создайте свою.',
    },
  },
  roles: {
    admin: 'Администратор',
    editor: 'Редактор',
    user: 'Пользователь',
  },
  auth: {
    email: 'Email',
    password: 'Пароль',
    newPassword: 'Новый пароль',
    name: 'Имя',
    signInTitle: 'Вход',
    signInSubmit: 'Войти',
    forgotLink: 'Забыли пароль?',
    forgotTitle: 'Восстановление пароля',
    forgotHint: 'Пришлём ссылку для смены пароля на ваш email.',
    forgotSubmit: 'Отправить ссылку',
    forgotSent: 'Если такой адрес зарегистрирован, письмо уже отправлено. Ссылка действует 1 час.',
    resetTitle: 'Новый пароль',
    resetSubmit: 'Сохранить пароль',
    resetDone: 'Пароль изменён, все сессии завершены. Войдите с новым паролем.',
    resetNoToken: 'Ссылка неполная. Запросите сброс пароля ещё раз.',
    passwordHint: 'Не короче 10 символов.',
    backToSignIn: 'Ко входу',
  },
  invite: {
    title: 'Регистрация по приглашению',
    role: 'Роль после регистрации: {{role}}',
    submit: 'Создать аккаунт',
    status: {
      used: 'Это приглашение уже использовано.',
      expired: 'Срок действия приглашения истёк. Попросите новое.',
      revoked: 'Приглашение отозвано.',
      invalid: 'Приглашение не найдено. Проверьте ссылку.',
    },
  },
  devices: {
    title: 'Устройства и сессии',
    current: 'Это устройство',
    unknownDevice: 'Неизвестное устройство',
    since: 'Вход: {{date}}',
    revoke: 'Завершить',
    empty: 'Активных сессий нет.',
  },
  hotkeys: {
    title: 'Горячие клавиши',
    hint: 'Горячие клавиши — «?»',
    actions: {
      search: 'Перейти к поиску на странице',
      catalog: 'Каталог',
      collections: 'Мои коллекции',
      stats: 'Статистика',
      new: 'Новая запись (в каталоге) или экземпляр (в коллекциях)',
      submit: 'Сохранить форму',
      help: 'Эта справка',
      close: 'Закрыть окно',
    },
  },
  a11y: {
    skipToContent: 'Перейти к содержимому',
    mainNav: 'Основная навигация',
  },
  history: {
    title: 'История изменений',
    journal: 'Журнал изменений каталога',
    journalHint: 'Правки общих записей каталога: кто, когда и что изменил.',
    empty: 'Изменений нет.',
    unknownUser: 'пользователь удалён',
    actions: {
      create: 'Создана',
      update: 'Изменена',
      visibility: 'Видимость',
      delete: 'Удалена',
      import: 'Импорт из Numista',
      variant_create: 'Добавлена разновидность',
      variant_update: 'Изменена разновидность',
      variant_delete: 'Удалена разновидность',
      image_add: 'Добавлено фото',
      image_remove: 'Удалено фото',
    },
    keys: {
      label: 'Разновидность',
      variant: 'Разновидность',
      visibility: 'Видимость',
      role: 'Фото',
      numista: 'N#',
    },
  },
  bulk: {
    select: 'Выбрать',
    cancel: 'Отменить выбор',
    selected: 'Выбрано: {{count}}',
    selectAll: 'Выбрать все на странице',
    selectItem: 'Выбрать: {{title}}',
    field: 'Изменить поле…',
    value: 'Новое значение',
    apply: 'Применить',
    visibility: 'Сменить видимость…',
    result: 'Изменено: {{updated}}.',
    failed: 'Не изменено: {{count}} — проверьте значения.',
  },
  adminMeta: {
    hint: 'Типы объектов, поля, значения, статусы и шкалы грейдов. Изменения сразу видны в формах, таблицах и фильтрах. Используемые записи нельзя удалить — только выключить: данные сохранятся.',
    tabs: {
      types: 'Типы',
      fields: 'Поля',
      enums: 'Значения',
      statuses: 'Статусы',
      grades: 'Грейды',
    },
    origin: { seed: 'исходное', customized: 'изменено', admin: 'своё' },
    usage: 'используется: {{count}}',
    unused: 'не используется',
    usageColumn: 'Использование',
    active: 'активно',
    activeFor: 'Активно: {{name}}',
    removeFor: 'Удалить: {{name}}',
    removeConfirm: 'Удалить «{{name}}»? Это действие нельзя отменить.',
    nameRu: 'Название',
    nameEn: 'Название (англ.)',
    nameFor: 'Название ({{code}})',
    code: 'Код',
    codeHint: 'Латиница в нижнем регистре, цифры и «_». Потом не меняется.',
    create: 'Создать',
    required: 'Обязательное',
    requiredFor: 'Обязательное: {{name}}',
    section: 'Раздел формы',
    sectionFor: 'Раздел: {{name}}',
    up: 'Выше',
    down: 'Ниже',
    types: {
      new: 'Новый тип',
      newHint: 'Название и эмитент подключаются сразу; остальные поля — после создания.',
      templateHint:
        'Коды полей в фигурных скобках, например {denomination_value} {years} — {issuer}.',
      defaultScale: 'Шкала грейдов по умолчанию',
      preview: 'Предпросмотр формы и фильтра →',
      fieldsHint:
        'Порядок, обязательность и раздел формы. Название и эмитент обязательны у любого типа.',
      addField: 'Добавить поле',
      saveFields: 'Сохранить состав полей',
      fieldsSaved: 'Состав полей сохранён — он уже действует в формах и фильтрах.',
    },
    fields: {
      new: 'Новое поле',
      core: 'встроенное',
      usage: 'типов: {{types}}, записей: {{records}}',
      enumSet: 'Набор значений',
      enumSetHint: 'Существующий или новый код набора; значения — на вкладке «Значения».',
      refKind: 'Справочник',
      listOf: 'Элементы списка',
      unit: 'Единица',
      min: 'Минимум',
      max: 'Максимум',
      maxLength: 'Максимальная длина',
      showInTable: 'Колонка в таблицах',
      filterable: 'В фильтрах',
      sortable: 'Сортировка',
    },
    dataTypes: {
      text: 'Текст',
      longtext: 'Длинный текст',
      integer: 'Целое число',
      decimal: 'Дробное число',
      boolean: 'Да/нет',
      date: 'Дата',
      partial_date: 'Неполная дата',
      year_range: 'Годы',
      enum: 'Выбор из списка',
      multi_enum: 'Несколько из списка',
      ref: 'Справочник',
      money: 'Сумма с валютой',
      grade: 'Грейд',
      list: 'Список',
      url: 'Ссылка',
    },
    enums: {
      usedBy: 'Используется в полях: {{fields}}',
      add: 'Добавить значение',
      none: 'Наборов значений нет — создайте поле типа «Выбор из списка».',
    },
    statuses: {
      hint: 'Статусы «В коллекции», «В поиске», «На продаже» и «Продано» использует приложение — их нельзя выключить.',
      color: 'Цвет',
      colorFor: 'Цвет: {{name}}',
      owned: 'В наличии',
      ownedFor: 'В наличии: {{name}}',
      add: 'Добавить статус',
    },
    grades: {
      newScale: 'Новая шкала',
      rank: 'Ранг',
      rankFor: 'Ранг: {{name}}',
      rankHint: 'Ранг 0–100 — общая ось для сравнения значений разных шкал (фильтр «грейд ≥ …»).',
      addValue: 'Добавить значение',
    },
    errors: {
      inUse: 'Запись используется — удалить нельзя. Её можно выключить: данные сохранятся.',
      codeTaken: 'Такой код уже есть.',
      core_field: 'Встроенное поле нельзя удалить или выключить.',
      system_status: 'Этот статус использует приложение — его нельзя удалить или выключить.',
      unknown_field: 'В шаблоне или составе есть неизвестное поле.',
      required_field: 'Поле «{{field}}» обязательно для любого типа.',
      required: 'Заполните обязательные параметры поля.',
      ref_not_found: 'Не найдено.',
      duplicates: 'Поле указано дважды.',
    },
  },
  admin: {
    usersTitle: 'Пользователи',
    referencesTitle: 'Справочники',
    metaTitle: 'Метаданные',
    changesTitle: 'Журнал',
    typesTitle: 'Предпросмотр форм',
    refKinds: {
      issuers: 'Эмитенты',
      periods: 'Периоды / правители',
      currency_units: 'Денежные единицы',
      mints: 'Монетные дворы',
      printers: 'Типографии',
      grading_services: 'Сервисы грейдинга',
      numbering_systems: 'Каталожные системы',
    },
    refFields: {
      name: 'Название',
      nameEn: 'Название (англ.)',
      code: 'Код',
      issuerId: 'Эмитент',
      yearFrom: 'С года',
      yearTo: 'По год',
      numistaId: 'Numista ID',
      mark: 'Знак',
      url: 'Сайт',
      appliesTo: 'Для типов',
      urlTemplate: 'Шаблон ссылки',
      isActive: 'Активен',
    },
    refNew: 'Новая запись',
    refEdit: 'Изменение записи',
    refShowInactive: 'Показывать неактивные',
    refDeactivate: 'Деактивировать',
    refActivate: 'Активировать',
    refInactive: 'неактивен',
    refUrlTemplateHint: '{number} заменяется номером',
    refAppliesToHint: 'Пусто — для всех типов',
    typesHint:
      'Типы и поля задаются seed-данными (packages/metadata). Здесь — просмотр и живой предпросмотр формы.',
    typeFields: 'Поля',
    typePreview: 'Предпросмотр формы',
    typePreviewHint:
      'Форма собрана из метаданных без кода под тип. Отправка только проверяет данные.',
    typePreviewValid: 'Данные прошли проверку:',
    level: 'Уровень',
    levels: { catalog: 'Каталог', variant: 'Разновидность', specimen: 'Экземпляр' },
    dataType: 'Тип данных',
    titleTemplate: 'Шаблон названия',
    invitesTitle: 'Приглашения',
    settingsTitle: 'Регистрация',
    registrationMode: 'Режим регистрации',
    modeInvite: 'Только по приглашению',
    modeOpen: 'Открытая',
    mailOff: 'SMTP не настроен: письма не отправляются, передавайте ссылки приглашений вручную.',
    mailOn: 'SMTP настроен: приглашения с email отправляются письмом.',
    createInvite: 'Создать приглашение',
    inviteEmail: 'Email (необязательно)',
    inviteEmailHint: 'Если указан — зарегистрироваться сможет только этот адрес.',
    inviteRole: 'Роль',
    inviteTtl: 'Срок, дней',
    inviteCreated: 'Приглашение создано. Ссылка одноразовая:',
    copy: 'Копировать',
    copied: 'Скопировано',
    revoke: 'Отозвать',
    anyEmail: 'любой email',
    columns: {
      name: 'Имя',
      email: 'Email',
      role: 'Роль',
      created: 'Создан',
      status: 'Статус',
      expires: 'Действует до',
      usedBy: 'Использовал',
    },
    inviteStatus: {
      valid: 'Действует',
      used: 'Использовано',
      expired: 'Истекло',
      revoked: 'Отозвано',
    },
  },
  errors: {
    INVALID_EMAIL_OR_PASSWORD: 'Неверный email или пароль.',
    RATE_LIMITED: 'Слишком много попыток. Подождите минуту.',
    INVITE_INVALID: 'Приглашение недействительно.',
    EMAIL_MISMATCH: 'Приглашение выдано на другой email.',
    EMAIL_TAKEN: 'Пользователь с таким email уже есть.',
    INVALID_TOKEN: 'Ссылка устарела или уже использована. Запросите сброс ещё раз.',
    UNAUTHORIZED: 'Нужно войти.',
    FORBIDDEN: 'Недостаточно прав.',
    NETWORK: 'Нет связи с сервером.',
    UNKNOWN: 'Что-то пошло не так. Попробуйте ещё раз.',
    notFound: 'Страница не найдена.',
    CODE_TAKEN: 'Такой код уже используется.',
    VERSION_CONFLICT: 'Запись уже изменили в другом окне. Обновите страницу.',
    VALIDATION_FAILED: 'Проверьте заполнение полей.',
    UNSUPPORTED_FORMAT: 'Формат не поддерживается.',
    FILE_TOO_LARGE: 'Файл слишком большой.',
    NOT_FOUND: 'Запись не найдена.',
    NUMISTA_NOT_CONFIGURED: 'Импорт из Numista не настроен: на сервере нет ключа API.',
    NUMISTA_QUOTA: 'Месячная квота запросов к Numista исчерпана.',
    NUMISTA_UNAVAILABLE: 'Numista не отвечает. Попробуйте позже.',
    INVALID_FILE: 'Файл не распознан: нужна JSON-выгрузка Numistic или CSV-таблица.',
    NAME_TAKEN: 'Такое название уже есть.',
    INBOX_PROTECTED: '«Входящие» нельзя удалить или переместить.',
    CYCLE: 'Нельзя переместить узел внутрь самого себя.',
    IN_USE: 'Используется — удалить нельзя.',
    validation: {
      required: 'Обязательное поле',
      email: 'Некорректный email',
      min_length: 'Слишком коротко',
      max_length: 'Слишком длинно',
      too_small: 'Слишком маленькое значение',
      too_big: 'Слишком большое значение',
      not_integer: 'Нужно целое число',
      not_number: 'Нужно число',
      pattern: 'Неверный формат',
      date: 'Некорректная дата',
      partial_date: 'Формат: ГГГГ, ГГГГ-ММ или ГГГГ-ММ-ДД',
      year_range_order: '«По» раньше, чем «с»',
      money_amount: 'Сумма — число, до 4 знаков после запятой',
      grade_scale: 'Неизвестная шкала',
      grade_value: 'Значение не из этой шкалы',
      duplicates: 'Значения повторяются',
      url: 'Некорректная ссылка (http/https)',
      uuid: 'Выберите значение из списка',
      code_format: 'Латиница, цифры, «-» и «_»',
      invalid: 'Некорректное значение',
      ref_not_found: 'Значение не найдено в справочнике',
      unknown_system: 'Неизвестная каталожная система',
      in_use: 'Используется — удалить нельзя',
      already_imported: 'Уже импортирован — пропущен',
      catalog_item_missing: 'Не найдена запись каталога (нужны тип, название и эмитент)',
    },
  },
} as const

export type Resources = typeof ru
